module.exports = __webpack_public_path__ + "img/5T_510k_otc.3e2e0948.jpg";